import HomePage from './pages/Home.vue'
import QuemSomosPage from './pages/QuemSomos.vue'
import ProdutosPage from './pages/Produtos.vue'
import SejaParceiroPage from './pages/SejaParceiro.vue'
import NovidadesPage from './pages/Novidades.vue'
import ContatoPage from './pages/Contato.vue'
import AcessoPage from './pages/Acesso.vue'
import PageNotFound from './pages/404.vue'

const routes = [
    {path: '/', component: HomePage},
    {path: '/quem-somos', component: QuemSomosPage},
    {path: '/produtos', component: ProdutosPage},
    {path: '/seja-um-parceiro', component: SejaParceiroPage},
    {path: '/seja-um-parceiro/acesso', component: AcessoPage},
    {path: '/novidades', component: NovidadesPage},
    {path: '/contato', component: ContatoPage},
    {path: '*', component: PageNotFound}
];

export default routes;


// WEBPACK FOOTER //
// ./resources/assets/src/routes.js